export const __channel = 'deprecated';

export * from './css';
export * from './deprecatedCss';
export * from './debug';
export * from './globalVars';
export * from './intentTypes';

export {
  createTheme,
  createThemeProvider,
  createMergeThemeProvider,
  themeAttributes,
  themeGlobals,
  themed,
} from './theme';
export {
  createIntrinsicViews,
  createView,
  View,
  view,
  continuationIntent,
} from './view';

export type {Theme, ThemedIntent} from './theme';
export type {Component, IntrinsicElement, IntrinsicViews} from './view';

export * as animate from './animate';
